export default function EstructuralesHeroBanner() {
  return <section id="estructurales-hero-banner" className="relative w-full h-48 md:h-64 flex items-center justify-center overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/industrial_steel_structure_bg.png)]" aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-black/40" aria-hidden="true" />

      {}
      <div className="relative z-10 text-center px-4 w-full max-w-7xl mx-auto">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white font-default tracking-wider uppercase drop-shadow-md">
          ESTRUCTURALES
        </h1>
      </div>
    </section>;
}